import * as React from 'react';
import { AlertTriangle } from 'react-feather';

export function DefaultDomInputErrorIconContent() {
  return <AlertTriangle />;
}
